export default __webpack_public_path__ + "static/media/iconAntiFraudInfo.3b58278b.svg";